// extracted by mini-css-extract-plugin
export default {"hoverButton":"EmailButton_hoverButton__Y+SW-"};